export function Listen(name) {
    return function (target, key, descriptor) {

        add(target, "Listen", key);

        const oldValue = descriptor.value;

        descriptor.value = function () {

            if (arguments[0] === 'mixin') {
                return target.$eventManager.add(window, name, oldValue.bind(this))
            } else {
                return oldValue.apply(this, arguments);
            }
        };

        return descriptor;
    };
}

const add = (target, name, functionName) => {
    if (!target.decorators) target.decorators = {};
    if (!target.decorators[name]) target.decorators[name] = [];

    target.decorators[name].push(functionName);
};

export function Subscribe(name) {
    return function (target, key, descriptor) {
        if (!target.subscriptions) target.subscriptions = [];

        target.subscriptions.push(
            target.$eventEmitter.subscribe(name, descriptor.value)
        );

        return descriptor;
    };
}
